'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../../src/styles/external.scss');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _apple = require('../../src/assets/apple.png');

var _apple2 = _interopRequireDefault(_apple);

var _pbd = require('../../src/assets/pbd.svg');

var _pbd2 = _interopRequireDefault(_pbd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement('img', { src: _apple2.default });

var _ref2 = _react2.default.createElement('img', { src: _pbd2.default });

var WidgetHome = function WidgetHome() {
	return _react2.default.createElement(
		'div',
		{ className: _style2.default.widgetHome },
		_react2.default.createElement(
			'div',
			{ className: _style2.default.container },
			_react2.default.createElement(
				'div',
				{ className: _style2.default.imageContainer },
				_ref
			),
			_react2.default.createElement(
				'div',
				{ className: _style2.default.imageContainer },
				_ref2
			)
		)
	);
};

WidgetHome.displayName = 'WidgetHome';

WidgetHome.defaultProps = {};

exports.default = WidgetHome;